import SmartToyIcon from '@mui/icons-material/SmartToy'
import { Avatar } from '@mui/material'

import './AIAvatar.scss'

export interface AIAvatarProps {
  className: string
}

const AIAvatar: React.FC<AIAvatarProps> = ({ className }) => {
  return (
    <div className="AIAvatar">
      <Avatar sx={{ bgcolor: 'primary.main' }} className={className}>
        <SmartToyIcon />
      </Avatar>
    </div>
  )
}

export default AIAvatar
